import { Filter } from '@vindr/ui';
import { ORDER_STATUS } from '@vindr/services/constants/order.constant';
import { filterBothValueAndKey } from '@vindr/utils/helpers/common.helper';
import { CaretDownOutlined } from '@vindr/icons';
import { DateRangePicker } from '@vindr/ui';
import { Input, Select } from 'antd';
import dayjs from 'dayjs';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FILTER_TYPE, MODALITIES } from './constants';
// import { useGetProceduresGroup } from '@vindr/services/actions/procedure.api';

const { Option } = Select;

const useSearchOptions = (params, handleOnChangeFilter) => {
  const { t } = useTranslation('Vindoc');
  const [openModality, setOpenModality] = useState(false);
  const [openStatus, setOpenStatus] = useState(false);
  // const procedureGroups =
  //   useGetProceduresGroup({ offset: 0, limit: 100, institution_ids: params?.institution_ids })?.data
  //     ?.data || [];

  const InputItem = (params, key, placeholder = t('Keyword')) => {
    return (
      <Input
        size="small"
        className="w-[200px]"
        value={params[key]}
        placeholder={placeholder}
        onChange={(event) => handleOnChangeFilter(params, key, event?.target?.value)}
        onPressEnter={(event) => {
          return handleOnChangeFilter(params, key, (event.target as HTMLInputElement).value, true);
        }}
        allowClear
      />
    );
  };

  return useMemo(
    () => [
      {
        text: t('Scheduled Date'),
        key: FILTER_TYPE.SCHEDULED_DATE,
        component: (
          <DateRangePicker
            size="small"
            value={[
              dayjs(params.scheduled_date_from || new Date()),
              dayjs(params.scheduled_date_to || new Date()),
            ]}
            // style={{ width: '100%' }}
            // formatDate={formatDate}
            // popupClassName="date-picker-light"
            onChange={(values: dayjs.Dayjs[]) => {
              handleOnChangeFilter(
                params,
                FILTER_TYPE.SCHEDULED_DATE,
                [values[0].startOf('days'), values[1].endOf('days')],
                true
              );
            }}
            disabledDate={() => false}
            allowClear
          />
        ),
      },
      {
        text: t('Status'),
        key: FILTER_TYPE.STATUS,
        component: (
          <Select
            size="small"
            mode="multiple"
            open={openStatus}
            onDropdownVisibleChange={(visible) => setOpenStatus(visible)}
            allowClear
            maxTagCount="responsive"
            suffixIcon={<CaretDownOutlined />}
            placeholder={t('Select Status')}
            className="select-dropdown-light w-[200px]"
            popupClassName="dropdown-options-dark"
            onChange={(value) => {
              if (window.innerWidth < 640) {
                setOpenStatus(false);
              }
              handleOnChangeFilter(params, FILTER_TYPE.STATUS, value, true);
            }}
            value={params[FILTER_TYPE.STATUS] || []}
          >
            <Option value={ORDER_STATUS.ARRIVED}>{t('ARRIVED')}</Option>
            <Option value={ORDER_STATUS.READING}>{t('READING')}</Option>
            <Option value={ORDER_STATUS.SUBMITTED}>{t('SUBMITTED')}</Option>
            <Option value={ORDER_STATUS.APPROVED}>{t('APPROVED')}</Option>
            <Option value={ORDER_STATUS.CANCEL}>{t('CANCEL')}</Option>
            <Option value={ORDER_STATUS.COMPLETED}>{t('COMPLETED')}</Option>
            <Option value={ORDER_STATUS.NEW}>{t('NEW')}</Option>
          </Select>
        ),
      },
      {
        text: t('Modality'),
        key: FILTER_TYPE.MODALITIES,
        component: (
          <Select
            size="small"
            mode="multiple"
            open={openModality}
            onDropdownVisibleChange={(visible) => setOpenModality(visible)}
            suffixIcon={<CaretDownOutlined />}
            placeholder={t('Select Modality')}
            className="select-dropdown-light w-[200px]"
            popupClassName="dropdown-options-dark"
            onChange={(value) => {
              if (window.innerWidth < 640) {
                setOpenModality(false);
              }
              handleOnChangeFilter(params, FILTER_TYPE.MODALITIES, value, true);
            }}
            value={params[FILTER_TYPE.MODALITIES] || []}
            allowClear
          >
            {MODALITIES.map((it) => (
              <Option key={it} value={it}>
                {it}
              </Option>
            ))}
          </Select>
        ),
      },
      {
        text: t('Patient Name'),
        key: FILTER_TYPE.PATIENT_NAME,
        component: InputItem(params, FILTER_TYPE.PATIENT_NAME, t('Enter Patient Name')),
      },
      {
        text: t('Patient ID'),
        key: FILTER_TYPE.PATIENT_ID,
        component: InputItem(params, FILTER_TYPE.PATIENT_ID, t('Enter Patient ID')),
      },
      {
        text: t('Institution'),
        key: FILTER_TYPE.INSTITUTION,
        component: (
          <Filter.Institution
            size="small"
            multiple
            className="select-dropdown-light w-[200px]"
            popupClassName="dropdown-options-dark"
            onChange={(value) => {
              handleOnChangeFilter(params, FILTER_TYPE.INSTITUTION, value, true);
            }}
            value={params[FILTER_TYPE.INSTITUTION] || []}
            filterOption={filterBothValueAndKey}
            title={false}
            allowClear
          />
        ),
      },
      {
        text: t('Visit ID'),
        key: FILTER_TYPE.VISIT_ID,
        component: InputItem(params, FILTER_TYPE.VISIT_ID, t('Enter Visit ID')),
      },
      {
        text: t('Order Group'),
        key: FILTER_TYPE.ORDER_GROUP,
        component: InputItem(params, FILTER_TYPE.ORDER_GROUP, t('Enter Order Group')),
      },
      {
        text: t('Study Description'),
        key: FILTER_TYPE.STUDY_DESC,
        component: InputItem(params, FILTER_TYPE.STUDY_DESC, t('Enter Study Description')),
      },
      // {
      //   text: t('Procedure Group'),
      //   key: FILTER_TYPE.PROCEDURE_GROUP,
      //   component: (
      //     <Select
      //       size="small"
      //       maxTagCount="responsive"
      //       suffixIcon={<CaretDownOutlined />}
      //       placeholder={t('Select')}
      //       className="select-dropdown-light w-[200px]"
      //       popupClassName="dropdown-options-dark"
      //       allowClear
      //       onChange={(value) => {
      //         handleOnChangeFilter(params, FILTER_TYPE.PROCEDURE_GROUP, value, true);
      //       }}
      //       value={params[FILTER_TYPE.PROCEDURE_GROUP] || []}
      //       filterOption={(input, option) =>
      //         String(option.children).toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
      //         option.key.toLowerCase().includes(input.toLowerCase())
      //       }
      //     >
      //       {procedureGroups
      //         ? procedureGroups.map((it, idx) => (
      //             <Select.Option key={idx} value={it?.id}>
      //               {it?.name}
      //             </Select.Option>
      //           ))
      //         : null}
      //     </Select>
      //   ),
      // },
    ],
    [t, params, handleOnChangeFilter]
  );
};

export default useSearchOptions;
